export default __webpack_public_path__ + "static/media/duplicate-icon.bbc4f42d.svg";